<!--
  - Copyright (c) 2022 by 安徽网才信息技术股份有限公司
  -
  - 除非事先获得版权所有人的许可, 禁止以下几项行为:
  - 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
  - 2. 向第三方透露任何与该软件相关的源代码或技术文档。
  - 3. 更改或删除软件或源码中的版权声明。
  -
  -->

<template>
    <div class="m-agenthead" :style="{background:'url(' + bgPic + ') no-repeat center center'}">
        <div class="m-box relative" style="margin-top: 0;">
            <div v-if="$store.state.agent === 'xinanpta'" class="u-logo">
                <img :src="logo" width="106" height="26" alt="" />
            </div>
            <div v-else class="u-logo" style="padding-top: 20px;">
                <img :src="logo" width="" height="60" alt="" />
            </div>
            <div class="clearfix pt-14">
                <div class="u-title">
                    <div class="u-logotxt">
                        {{ $store.state.meta.title }}
                    </div>
                </div>
                <div class="fr u-login">
                    <router-link v-if="!$store.getters['hasLogin']" :to="{name: 'login'}">
                        注册/登录
                    </router-link>
                    <el-dropdown v-if="$store.getters['hasLogin']" class="logout" @command="handleCommand">
                        <span class="el-dropdown-link">
                            hi, {{ $store.state.userInfo.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-if="!$store.state.userInfo.setPassword" command="password">
                                设置密码
                            </el-dropdown-item>
                            <el-dropdown-item v-else command="modifyPassword">
                                修改密码
                            </el-dropdown-item>
                            <el-dropdown-item command="feedback">
                                我的反馈
                            </el-dropdown-item>
                            <el-dropdown-item command="logout">
                                退出
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div :class="$config.stAgents.includes($store.state.agent) ? 'm-agentnav-green' : 'm-agentnav'">
                <router-link :to="{name: 'home'}" active-class="on">
                    首页
                </router-link>
                <router-link :to="{name: 'notice'}" active-class="on">
                    {{ $config.ycAgents.includes($store.state.agent) ? '招聘公告' : '考试公告' }}
                </router-link>
                <router-link :to="{name: 'project'}" active-class="on">
                    网上报名
                </router-link>
                <router-link :to="{name: 'my'}" active-class="on">
                    我的报考
                </router-link>
            </div>
        </div>
        <!--   设置密码     -->
        <el-dialog title="设置密码" :visible.sync="dialogFormVisible" width="600px">
            <el-form ref="ruleForm" :model="form" status-icon :rules="rules">
                <el-form-item label="登录密码" :label-width="formLabelWidth" prop="password">
                    <el-input v-model="form.password" type="password" autocomplete="off" placeholder="6-20位字母、数字、符号组合" />
                </el-form-item>
                <el-form-item label="确认密码" :label-width="formLabelWidth" prop="confirmPassword">
                    <el-input v-model="form.confirmPassword" type="password" autocomplete="off" placeholder="确认密码" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">
                    取 消
                </el-button>
                <el-button type="primary" @click="setPassword">
                    确 定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import { setPassword } from '@/api/user';
export default {
    name: 'LayoutHeader',
    data() {
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.form.confirmPassword !== '') {
                    this.$refs.ruleForm.validateField('confirmPassword');
                }
                callback();
            }
        };
        const validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            logo: require('@/assets/images/r_wlogo.svg'),
            bgPic: require('@/assets/images/dl_bg.png'),
            navList: [
                {
                    id: 2,
                    title: '考试公告',
                    name: 'notice'
                },
                {
                    id: 3,
                    title: '网上报名',
                    name: 'project'
                },
                {
                    id: 4,
                    title: '我的报考',
                    name: 'my'
                }
            ],
            form: {
                oldPassword: '',
                password: '',
                confirmPassword: ''
            },
            dialogFormVisible: false,
            dialogFormVisible2: false,
            formLabelWidth: '120px',
            rules: {
                password: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                confirmPassword: [
                    { validator: validatePass2, trigger: 'blur' }
                ]
            }
        };
    },
    watch: {
        '$store.state.meta': {
            handler: function(newVal) {
                this.logo  = newVal.logo;
                this.bgPic = newVal.bgPic;
            }
        }
    },
    created() {
        if (!this.$config.wcAgents.includes(this.$store.state.agent)) {
            this.navList.unshift({
                id: 1,
                title: '首页',
                name: 'home'
            });
        }
        this.$store.dispatch('getUserInfo');
    },
    methods: {
        handleCommand(command) {
            if (command === 'logout') {
                this.$store.dispatch('handleLogout');
                this.$message.success('退出成功');

                setTimeout(() => {
                    this.$router.replace({name: 'home'});
                    /*if (['user-center', 'user-set', 'apply'].includes(this.$route.name)) {
                        this.$router.replace({name: 'login'});
                    }*/
                }, 2000);
            } else if (command === 'password') {
                this.showSetPassword();
            } else if (command === 'modifyPassword') {
                this.$router.push({
                    name: 'change-password'
                });
            } else if (command === 'feedback') {
                this.$router.push({
                    name: 'feedback'
                });
            }
        },
        showSetPassword() {
            this.dialogFormVisible = true;
            this.form.password = '';
            this.form.confirmPassword = '';
        },
        // 设置密码
        setPassword() {
            this.$refs['ruleForm'].validate(async(valid) => {
                if (valid) {
                    await setPassword({password: this.form.password});
                    this.$message.success('设置成功');
                    this.dialogFormVisible = false;
                    await this.$store.dispatch('getUserInfo');
                } else {
                    return false;
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.logout{
    display: inline-block;
    padding: 9px 8px;
    background: #fff;
    border-radius: 16px;
    text-align: center;
    color: #0D316B;
    font-size: 14px;
}
.m-agentnav {
    background: var(--themeColor);
}
.m-list li .u-dot {
    background: var(--themeColor);
}
.m-enrolcard ul li .enrol-btn a {
    color: var(--themeColor);
}
</style>
